<template>
	<Popup
		v-model="selfDisplay"
		title="充值"
		@confirmClick="handleConfirmClick"
	>
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_form_row">
				<span class="b_label">名称</span>
				<el-input :value="name" disabled></el-input>
			</div>
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label">账号</span>
				<el-input :value="code" disabled></el-input>
			</div>
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label">产品</span>
				<el-select v-model="product" style="width: 100%;">
					<el-option v-for="v in products" :key="v.id" :value="v.id" :label="v.name"></el-option>
				</el-select>
			</div>
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label">操作</span>
				<el-select v-model="action" style="width: 100%;">
					<el-option value="1" label="充值"></el-option>
					<el-option value="2" label="赠送"></el-option>
					<el-option value="3" label="扣除"></el-option>
				</el-select>
			</div>
			<div v-if="objectType == 0 && (product == 0 || product == 1)" class="base_form_row clear_both" style="margin-top: 20px;">
				<span class="b_label">当前处方信息</span>
				<div v-for="(v, i) in show_preList" :key="i" class="b_block" style="width: 245px;" :style="{'margin-right': i % 2 ? '0px' : '23px'}">
					<div style="font-size: 14px;line-height: 36px;">{{ v.name }}</div>
					<el-input :value="v.num" disabled></el-input>
				</div>
			</div>
			<div v-if="objectType == 0" class="base_form_row" style="margin-top: 20px;">
				<span class="b_label">充值天数</span>
				<el-input v-model="days" placeholder="充值天数"></el-input>
			</div>
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label">次数</span>
				<el-input v-model="num" :disabled="objectType == 0"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="num_tip"><i class="b_icon"></i>充值次数格式不正确</template></div>
			<div class="base_form_row">
				<span class="b_label">备注</span>
				<el-input v-model="desc" maxlength="100" :show-word-limit="true" placeholder="备注"></el-input>
			</div>
		</div>
	</Popup>
</template>

<script>
	import Api from "../../../../../api/index.js"
	
	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			id: {
				type: String,
				required: true
			},
			name: {
				type: String,
				required: true
			},
			code: {
				type: String,
				required: true
			},
			products: {
				type: Array,
				required: true
			},
			objectType: {
				type: [String, Number],
				required: true
			}
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data () {
			return {
				loading: false,
				selfDisplay: false,
				product: '',
				action: '1',
				preList: [],
				show_preList: [],
				days: 1,
				num: 1,
				desc: '',
				num_tip: false
			}
		},
		methods: {
			/*********************** @Events ***********************/
			// 点击充值
			handleConfirmClick () {
				const that = this;
				if (!that.positiveReg.test(that.num)) {
					that.num_tip = true;
					return false;
				} else {
					that.num_tip = false;
				}
				that.loading = true;
				var _request = {
					category: that.action,
					coverCode: that.code,
					coverEnterpriseId: that.id,
					coverName: that.name,
					dayNumber: null,
					id: null,
					num: that.num,
					objectType: that.objectType,
					payType: 1,
					utakeType: null,
					versionFlag: that.product,
					umemo: that.desc
				};
				Api.recharge(_request).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.$emit("success", res.data.message);
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			
			/*********************** @Function ***********************/
			// 初始化
			init () {
				if (this.objectType == 0) {	// 用户
					this.product = this.products.length
						? this.products[0].id
						: '';
					this.getPrescriptionData();
				} else if (this.objectType == 1) {	// 组织机构
					this.product = this.products.length
						? this.products[0].id
						: '';
				}
			},
			// 还原
			reset () {
				this.loading = false;
				this.product = '';
				this.action = '1';
				this.preList = [];
				this.show_preList = [];
				this.days = 1;
				this.num = 1;
				this.desc = '';
				this.num_tip = false;
			},
			// 获取处方信息
			getPrescriptionData () {
				const that = this;
				that.loading = true;
				var requestData = {
					uCode : that.code,
					uEnterpriseId: that.id
				};
				Api.findAgentPrescription(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.preList = [];
						res.data.data.forEach((v, i) => {
							var _info = v.paramsInfo ? v.paramsInfo.split(",") : [];
							var _type = v.paramsName ? v.paramsName.split(",") : [];
							that.preList.push({
								id: v.productId,
								child: []
							});
							_info.forEach((vi, ii) => {
								that.preList[i].child.push({
									num: parseInt(vi),
									type: _type[ii],
									name: v.eglProductParamsDetailsVo[ii].name
								});
							});
						});
						that.showPreByProduct();
						that.setNumByPreAndDays();
					} else {
						that.selfDisplay = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.prescription_loading = false;
					that.selfDisplay = false;
					that.$message.error(e.message);
				});
			},
			// 根据产品显示对应处方信息
			showPreByProduct () {
				const that = this;
				if (that.objectType == 0 && (that.product == 0 || that.product == 1)) {
					that.preList.forEach(v => {
						v.id == that.product && (that.show_preList = v.child);
					});
				} else {
					that.show_preList = [];
				}
			},
			// 根据处方信息计算总次数
			setNumByPreAndDays () {
				if (this.objectType == 0) {
					if (this.product == 0 || this.product == 1) {
						var pre_num = 0;
						this.show_preList.forEach(v => {
							pre_num += v.num;
						});
						if (this.positiveReg.test(this.days)) {
							this.num = pre_num > 0 ? pre_num * this.days : this.days;
						} else {
							this.num = '';
						}
					} else {
						this.positiveReg.test(this.days) ? this.num = this.days : (this.num = '');
					}
				}
			}
		},
		watch: {
			display (newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay (newVal) {
				this.$emit("changeDisplay", newVal);
				if (!newVal) {
					this.reset();
				} else {
					this.init();
				}
			},
			days () {
				this.setNumByPreAndDays();
			},
			product () {
				this.showPreByProduct();
				this.setNumByPreAndDays();
			}
		}
	}
</script>

<style>
</style>
